import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const updatingIntegration = {
  element: '#integration-section',
  popover: {
    title: 'Updating an Integration',
    description:
      'You can modify the name, status, parameters and fallback text. Additionally, you can view integration diagnostics. Use these options to modify an integration to meet your specific needs.',
    showButtons: ['next']
  }
};
